export const CAROUSEL_INTERVAL = 5000;

export const PAYMENT_LOCALES = ['es-cl', 'es-co', 'es-ec', 'es-mx', 'es-pe'];
